<template>
  <div class="container">
    <van-image width="100%" :src="require('@/assets/download/badge.png')" />
    <van-image style="display: block; margin: -60px auto 0;" width="72%" :src="require('@/assets/download/APPxiazai@2x.png')" />
    <van-image style="display: block; margin: 50px auto 0;" width="40%" @click="dowmloadClick('https://apps.apple.com/cn/app/%E5%B1%B1%E8%A5%BF%E5%8D%9A%E7%89%A9%E9%99%A2-shanxi-museum/id1299404572')" :src="require('@/assets/download/IOS@2x.png')" />
    <van-image style="display: block; margin: 20px auto 100px;" width="40%" @click="dowmloadClick('https://sj.qq.com/appdetail/com.hengda.smart.sxbwg.m?source=gamedetail')" :src="require('@/assets/download/Android@2x.png')" />
    <van-image class="logo" style="marginTop: 50px" width="30%" :src="require('@/assets/download/logo@2x.png')" />
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    dowmloadClick (url) {
      window.location.href = url
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-image: url('../../assets/down-bj@2x.png');
  background-size: 100% 100%;
  text-align: center;
  overflow: hidden;
  .logo {
    margin: 0 auto 40px;
    width: 183px;
  }
}
</style>
